<template>
  <div
    class="message__user animate__animated animate__fadeInUp animate__fastest"
    :class="{'underline': needUnderlined}"
    id="conversation-user-message"
  >
    {{ message.content }}
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: Object,
      default: () => ({}),
    },
    needUnderlined: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.message__user {
  @apply bg-purple-60 text-base-0 text-sm;
  @apply rounded-xl py-3 px-4 mb-3 break-words;
  max-width: 270px;
}
</style>
